/*
 * @Author: shiguang
 * @Date: 2023-04-26 10:50:23
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-07-15 15:34:14
 * @Description: 路由页面
 */
import { ComponentType, LazyExoticComponent, lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

export type RouteItem = RouteObject & {
	/** 是否需要右侧自定义按钮 */
	isNeedNavBarRight?: boolean;
	/** 是否展示tabbar */
	showTabBar?: boolean;
	/**
	 * 路由对应的页面
	 */
	component?: LazyExoticComponent<ComponentType<any>> | ComponentType<any>;
	/**
	 * 路由地址
	 */
	path: string;
	/**
	 * 父级路由，用于menu的高亮判断，例如 detail 页面 要定位到 列表页面 菜单上
	 */
	activePath?: string;
	/**
	 * 默认false，如果为true时，需要和路由相同时才能匹配，但是如果有斜杠也是可以匹配上的。
	 */
	exact?: boolean;
	/**
	 * 是否严格匹配斜杠结尾
	 */
	strict?: boolean;
	/**
	 * 页面标题
	 */
	title?: string;
	/**
	 * 图标
	 */
	icon?: React.ReactNode;
	layout?: React.FC<any>;
	/**
	 * 显示左侧菜单，默认为true
	 */
	showMenu?: boolean;
	/**
	 * 显示左侧菜单，默认为true
	 */
	showSlider?: boolean;
	/**
	 * 显示头部，默认为true，如果设为false，则无头部组件
	 */
	showHeader?: boolean;
	/** 页面权限code */
	pagePermissionCode?: string;
	/** 操作权限code */
	actionPermissionCode?: string[];
	// 嵌套路由
	children?: RouteItem[];
};
// https://static-s.theckb.com/BusinessMarket/App/Icon/h5商详推广页logo/落地页.png

export const ROUTER_INDEX_NAME = '/promotion/home';

const router: RouteItem[] = [
	{
		path: '/',
		title: '',
		component: () => {
			return <Navigate to={`${ROUTER_INDEX_NAME}`} />;
		}
	},
	{
		path: '/*',
		title: '迷失方向',
		component: function () {
			return <div>{window._$m.t('您似乎迷失了方向')}~</div>;
		}
	},
	{
		path: '/dev/login',
		title: '登录',
		component: lazy(() => import('../../container/dev/Login'))
	},
	{
		path: '/promotion/goodsDetail',
		title: '推广/商品详情',
		component: lazy(() => import('../../container/promotion/GoodsDetail'))
	},
	{
		path: '/promotion/download',
		title: '推广/app下载',
		component: lazy(() => import('../../container/promotion/Download'))
	},
	{
		path: '/promotion/ImageSearchList',
		title: '图搜列表',
		component: lazy(
			() => import('../../container/promotion/ImageSearchList')
		)
	},
	{
		path: '/promotion/Pallet1688List',
		title: '1688货盘列表',
		component: lazy(
			() => import('../../container/promotion/Pallet1688List')
		)
	},
	{
		path: '/promotion/home',
		title: '首页',
		component: lazy(() => import('../../container/promotion/Home'))
	},
	{
		path: '/promotion/search/list',
		title: '搜索列表',
		component: lazy(() => import('../../container/promotion/SearchList'))
	},
	{
		path: '/promotion/chat',
		title: '聊天页面',
		component: lazy(() => import('../../container/promotion/Chat'))
	}
];
export default router;
